import { Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledMenu = styled(Menu)`
  z-index: 2001;

  .MuiPopover-paper {
    border-radius: 4px;
  }
`;
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.grey[800],
  "&:hover": {
    backgroundColor: theme.palette.primary[50]
    // aqua mapped to primary
  }
}));
export {
  StyledMenu,
  StyledMenuItem
};
